'use strict';
$(window).scroll(function () {
    if ($(window).scrollTop() > 0) {
        $('body').addClass('nav-sticky');
    } else {
        $('body').removeClass('nav-sticky');
    }
});
// 268515
